import { CostReportSummary } from '@cast/types';

export const emptySummary: CostReportSummary = {
  totalCost: 0,
  totalCpuCost: 0,
  totalRamCost: 0,
  totalGpuCost: 0,
  totalTpuCost: 0,
  totalStorageCost: 0,
  avgCost: 0,
  avgCpuCost: 0,
  avgRamCost: 0,
  avgGpuCost: 0,
  avgTpuCost: 0,
  avgStorageCost: 0,
  avgCpuCount: 0,
  avgRamGib: 0,
  avgGpuCount: 0,
  avgTpuCount: 0,
  avgStorageGib: 0,
  totalCostOnDemand: 0,
  totalCostSpot: 0,
  totalCostSpotFallback: 0,
  avgCpuCountOnDemand: 0,
  avgCpuCountSpot: 0,
  avgCpuCountSpotFallback: 0,
  avgRamGibOnDemand: 0,
  avgRamGibSpot: 0,
  avgRamGibSpotFallback: 0,
  avgGpuCountOnDemand: 0,
  avgGpuCountSpot: 0,
  avgGpuCountSpotFallback: 0,
  avgTpuCountOnDemand: 0,
  avgTpuCountSpot: 0,
  avgTpuCountSpotFallback: 0,
  avgCpuCostOnDemand: 0,
  avgCpuCostSpot: 0,
  avgCpuCostSpotFallback: 0,
  avgRamCostOnDemand: 0,
  avgRamCostSpot: 0,
  avgRamCostSpotFallback: 0,
  avgGpuCostOnDemand: 0,
  avgGpuCostSpot: 0,
  avgGpuCostSpotFallback: 0,
  avgTpuCostOnDemand: 0,
  avgTpuCostSpot: 0,
  avgTpuCostSpotFallback: 0,
};
